// Yup
import { object, string } from 'yup';

import { addressSchema } from './addressSchema';

const companySchema = object().shape({
  name: string().required('Campo nome obrigatório'),
  cnpj: string()
    .required('Campo CNPJ obrigatório')
    .matches(/^\d{2}\.\d{3}\.\d{3}\/\d{4}-\d{2}$/g, {
      message: 'Digite um CNPJ válido',
    }),
  phone: string().matches(/\(\d{2,}\) \d{4,}\-\d{4}/g, {
    message: 'Digite um número válido',
  }),
  email: string().email('Por favor digite um e-mail válido'),
  address: addressSchema,
});

export default companySchema;
export { companySchema };
